import { Icon24DescribeAudioLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const AudioDescriberIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M16.0203 11.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0203 14.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17.1819L22 17.1819"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77026 20.3H22.0203"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2405 10.7917H4.06742C3.92716 10.7917 3.79265 10.7434 3.69347 10.6574C3.59429 10.5715 3.53857 10.4549 3.53857 10.3333V6.66667C3.53857 6.54511 3.59429 6.42853 3.69347 6.34258C3.79265 6.25662 3.92716 6.20833 4.06742 6.20833H7.2405L12.0001 3V14L7.2405 10.7917Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.24048 6.2085V10.7918"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AudioDescriberIcon = fplIcon(AudioDescriberIconLocal, Icon24DescribeAudioLarge);
